import { cn } from "@/lib/utils";

type Props = {
    className?: string;
};

const DividerHorizontal = ({ className }: Props) => {
    return (
        <>
            <div className={cn("w-full h-[1px] bg-[#1d1d1f] bg-opacity-20 my-6", className)}></div>
        </>
    );
};

export default DividerHorizontal;
